/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as ActionTypes from './actionTypes';

const initialState = {
  computedFileds: [],
  rebateProgram: '',
  rebateProgramList: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  selectedRows: [],
  manufacturerList: [],
  reportQuarter: 'All',
  amountNdcDetails: [],
  ndcCodes: [],
  threshold: '',
  useBalanceThreshold: true,
  plan: '',
  dramsInvoice: '',
  earliestQtr: '',
  errors: [],

  exportAllDataComputedFields: [],
  exportAllDataNDCCodes: [],
  displayObj: {
    countValue: null,
    selectedPlanType: '',
    rebateProgram: '',
    selectedRows: [],
    reportQuarter: 'All',
    useBalanceThreshold: true,
    plan: '',
    isAll: false,
    computedFileds: [],
    ndcCodes: [],
    dramsInvoice: '',
    earliestQtr: '',
    rebateProgramList: [],
    rebateProgrameName: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_DISPUTE_AMOUNT:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_MANUFACTURERS_LIST_DIISPUTE_AMOUNT:
      return { ...state, manufacturerList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_UNALLOCATED:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.SET_COMPUTED_FIELDS:
      let displayObj = {
        ...state.displayObj,
        computedFileds: action.payload,
      };
      return { ...state, computedFileds: action.payload, displayObj };
    case ActionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE:
      return {
        ...state,
        dramsInvoice: action.payload,
      };
    case ActionTypes.GET_EARLIEST_QTR_DRUG_VALUE:
      return {
        ...state,
        earliestQtr: action.payload,
      };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SET_BALANCE_THREAD:
      return { ...state, threshold: action.payload };
    case ActionTypes.SET_AMOUNT_NDC_DETAILS:
      return { ...state, amountNdcDetails: action.payload };

    case ActionTypes.SET_AMOUNT_NDC_DETAILS_EXPORT_ALL:
      return { ...state, exportAllDataComputedFields: action.payload };
    case ActionTypes.SET_AMOUNT_NDC_CODES_EXPORT_ALL:
      return { ...state, exportAllDataNDCCodes: action.payload };
    case ActionTypes.SET_NDC_CODES:
      let displayData = {
        ...state.displayObj,
        ndcCodes: action.payload,
      };
      return { ...state, ndcCodes: action.payload, displayObj: displayData };
    case ActionTypes.REFRESH_DISPUTE_AMOUNT:
      return {
        ...state,
        rebateProgram: '',
        reportQuarter: 'All',
        useBalanceThreshold: true,
        isAll: false,
        plan: '',
      };
    case ActionTypes.SET_PAGINATION_INDEX_DISPUTE_AMOUNTS:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    case ActionTypes.REFRESH_DISPUTE_AMOUNT_DISPLAY:
      return {
        ...state,
        rebateProgram: '',
        reportQuarter: 'All',
        useBalanceThreshold: true,
        isAll: false,
        plan: '',
      };

    default:
      return state;
  }
};

export default reducer;
